// extracted by mini-css-extract-plugin
module.exports = {"aboutPageSection":"about-page-section-module--aboutPageSection--2LlBw","imageContainer":"about-page-section-module--imageContainer--1GNbn"};